// extracted by mini-css-extract-plugin
module.exports = {"labelWrapper":"ContributorsLabel_labelWrapper__sknFV","label":"ContributorsLabel_label__ae5Ee","labelDark":"ContributorsLabel_labelDark__VhWt8"};